import Model from "../../common/Model";

const YoutubeVisualsForm = ({ onClose, editId, handleSubmit, values, handleChange, handleBlur, touched, errors, loading, handleImageChange, preview }) => {
  return (
    <Model closeModal={onClose} title={`${editId ? "Edit" : "Add"} Youtube Visuals`} isForm={true} loading={loading} handleSubmit={handleSubmit}>
      <div>
        <label className="text-sm font-medium text-foreground">Thumbnail Image</label>
        <input type="file" name="thumbnail" onChange={handleImageChange} className="w-full px-4 py-2 border border-border rounded-xl" />
        {touched.thumbnail && errors.thumbnail && <div className="text-red-500 text-sm">{errors.thumbnail}</div>}
        {preview && (
          <div className="mt-4 flex">
            <p className="text-md text-foreground me-3">Preview:</p>
            <img src={preview} alt="preview" className="w-24 h-24 object-cover border border-border rounded-xl" />
          </div>
        )}
      </div>
      <div className="mt-3">
        <label className="text-sm font-medium text-foreground">Title</label>
        <input type="text" name="title" className="w-full px-4 py-2 border border-border rounded-xl" value={values.title} onChange={handleChange} onBlur={handleBlur} placeholder="Youtube Visuals Title" />

        {touched.title && errors.title && <div className="text-red-500 text-sm">{errors.title}</div>}
      </div>
      <div className="mt-3">
        <label className="text-sm font-medium text-foreground">Link</label>
        <input type="text" name="link" className="w-full px-4 py-2 border border-border rounded-xl" value={values.link} onChange={handleChange} onBlur={handleBlur} placeholder="Youtube Visuals Link" />
        {touched.link && errors.link && <div className="text-red-500 text-sm">{errors.link}</div>}
      </div>
    </Model>
  );
};

export default YoutubeVisualsForm;
